import { render, staticRenderFns } from "./add-region-popup.vue?vue&type=template&id=24ba4290"
import script from "./add-region-popup.vue?vue&type=script&lang=js"
export * from "./add-region-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports